/**
 * OVERRIDE: EditBlockWrapper.jsx
 * REASON: Removing duplicated className in wrapper only in v3 blocks & add category className to block-editor-{type}
 * DATE: 2024-02-01
 * DEVELOPER: @sneridagh
 */
import EditBlockWrapper from '../../../../../../components/Blocks/Block/EditBlockWrapper';

export default EditBlockWrapper;
